<template>
  <div class="minwidth w100 mw100" style="background-color: #0E2038;">
    <tabbar></tabbar>

    <div>
      <div class="positionrel w100">
        <img :src="require('../../public/img/join/bg3.png')" class="positionabs" />
        <div
          style="color: #fff;font-size: 3rem;position: absolute;top: 8rem;left: 50%;transform: translate(-50%);width: 50%;text-align: center;">
          学习中心
          <div
            style="text-align: center;color: #fff;cursor: pointer;background-color: #06D1ED;width: 30%;margin: 0 auto;height: 2rem;line-height: 2rem;border-radius: 2rem;font-size: 0.8rem;margin-top: 1rem;"
            @click="gotoJoin">获取信息服务</div>
        </div>
      </div>

      <div style="display: flex;flex-wrap: wrap;justify-content: center;padding: 2rem 0;">
        <div v-for="(item,index) in partList" :key="index" style="width: 25%;padding: 1rem 0;">
          <div style="width: 90%;margin: 0 auto;box-shadow: 0 4px 4px rgba(0, 0, 0, .02);border-radius: 1rem;padding-bottom: 1rem;background-color: #fff;">
            <div>
              <img style="width: 100%;display: block;border-radius: 1rem 1rem 0 0;" :src="item.url" alt="">
            </div>
            <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 90%;margin: 0 auto;margin-top: 0.5rem;">
              {{ item.title }}
            </div>
            <div style="display: flex;justify-content: end;width: 90%;margin: 0 auto;margin-top: 1rem;cursor: pointer;">
              <div style="width: 60%;height: 2rem;border-radius: 2rem;line-height: 2rem;border: 0.1rem solid #1966ff;color: #1966ff;text-align: center;font-size: 0.9rem;" @click="gotoLogin">*50元注册立即学习</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To1
          </div>
          <div>
            <div style="font-size: 1.8rem;">深度剖析中国信通院发布的未来十大趋势</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul1_1.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            一、ICT产业创新发展开新局，制造业服务业交替上升；二、大模型多维度快速演进，微笑曲线两端率先发力；<br>
            三、AI终端开启变革新浪潮，端侧软硬生态变革重塑；四、智能算力步入万卡时代，全盘调度提升计算效率；<br>
            五、网络智能双向融合赋能，智算推动网络演进创新；六、5G-A无线技术集成创新，通感智融合拓展新空间；<br>
            七、网络防御转向协同实战，智能安全范式加速形成；八、数字技术全面规模赋能，点线面系统化推进转型；<br>
            九、数实融合释放需求潜力，全要素生产率持续提升；十、治理体系改革持续深化，国际治理合作大有可为。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To2
          </div>
          <div>
            <div style="font-size: 1.8rem;">深度剖析信息通信行业和融合领域发展态势？</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            设置四大主题板块，二十二个前沿领域专题报告，涵盖数字技术创新、人工智能、6G、低空经济、机器人、数据安全等。<br>
            包括《新型工业化-中国工业由大到强的战略、理论和实践》《解码数字中国-战略路径与未来发展》《量子前沿-解密未来技术与产业生态》《车联网新动力-数智变革赋能汽车产业转型》《低碳未来-数字化与绿色化融合之路》五本学术著作。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul2_1.png')" alt="">
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To3
          </div>
          <div>
            <div style="font-size: 1.8rem;">为什么全球新能源产业链建成！下一步怎么走？</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul3_1.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            续推能源转型，还需要直面转型中的挑战。由于电力系统接纳新能源的能力受到电源、负荷、网架等多重因素限制，新能源装机规模的持续高速增长使得电力供应超过负荷需求，电力平衡和能源消纳问题随之而来。<br>
            　2024年，中国建成全球完整的新能源产业链，光伏组件产量连续16年位居世界首位，为全球提供了70%的光伏组件和60%的风电装备，有力降低全球风电和光伏发电成本。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To4
          </div>
          <div>
            <div style="font-size: 1.8rem;">如何构建算力互联网，实现异构算力</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            算力互联网分论坛”期间，中国信通院副院长魏亮表示，大数据、人工智能等新兴技术快速发展，算力需求呈现爆发式增长。构建算力互联网，实现异构算力的智能感知、实时发现和随需获取，是提升资源利用率，夯实数字经济发展底座的重要环节。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul4_1.png')" alt="">
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To5
          </div>
          <div>
            <div style="font-size: 1.8rem;">如何打造商业秘密安全防护？</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul5_1.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            保护商业秘密，构建更加和平安全的网络空间。采用硬件安全载体、国密算法、信源加密等技术，为党政机关、事业单位、央国企等用户提供办公与生活场景下的移动终端加密服务，为国家安全、社会数据及企业机密提供保障。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To6
          </div>
          <div>
            <div style="font-size: 1.8rem;">新型消费五大趋势引领未来市场新方向</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            当前新型消费正展现出数智化、绿色化、健康化、国潮化以及即时零售化的特点。数智消费方面，线上平台与智能技术的融合，不仅促进了供需两端的精准匹配，还带动了智能化产品的爆发式增长，新技术、新服务在线上平台的涌现，进一步拓宽了消费边界。<br>
            绿色消费趋势同样显著，随着消费者对环保意识的提升，低碳、节能的产品成为市场新宠，电商平台上，一级能效标识的家电产品销量大增，彰显了绿色消费理念的深入人心。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul6_1.png')" alt="">
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To7
          </div>
          <div>
            <div style="font-size: 1.8rem;">工业5G独立专网将具备哪五大特征？</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul7_1.png')" alt="">
          </div>
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            在技术创新领域，5G-A的研发与部署成为核心驱动力。今年我国运营商已正式启动5G-A商用，其超大上下行、轻量化技术成为现阶段推进重点。中国移动、电信、联通聚焦RedCap及载波聚合等能力建设，广电也积极参与全频RedCap部署。展望未来，确定性低时延、通感一体等技术将接力成为发力方向，为工业互联网持续赋能，提前导入6G融合技术理念，助力产业技术迭代。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
        <div
          style="width: 85%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;margin-right: 0.5rem;">
            To8
          </div>
          <div>
            <div style="font-size: 1.8rem;">下一代数据治理体系架构将呈现的6大趋势</div>
          </div>
        </div>
        <div
          style="width: 85%;margin: 0 auto;margin-top: 2rem;display: flex;align-items: center;justify-content: space-between;">
          <div style="width: 60%;text-align: justify;line-height: 2.5rem;font-size: 1.2rem;">
            据统计2023年我国数据生产总量达到了32.85ZB，同比增长高达22.44%，数据产业规模已达2万亿元。政策方面，国家高度重视数据产业发展，2020年以来陆续出台了10多项政策文件，覆盖数据基础制度、数据整合利用、数据基础设施与数据管理能力建设。<br>
            <div
              style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;font-weight: bold;"
              @click="gotoLogin">
              *20元注册了解详情 >>>
            </div>
          </div>
          <div style="width: 37%;">
            <img style="width: 100%;display: block;margin: 0 auto;"
              :src="require('../../public/img/trends/consul8_1.png')" alt="">
          </div>
        </div>
      </div> -->

      <!-- <div
        style="display: flex;justify-content: space-around;margin-top: 1rem;flex-wrap: wrap;margin-bottom: 2rem;color: #fff;">
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul1_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            深度剖析中国信通院发布的未来十大趋势
          </div>
          <div
            style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;text-align: center;">
            一、ICT产业创新发展开新局，制造业服务业交替上升；<br>
            二、大模型多维度快速演进，微笑曲线两端率先发力；<br>
            三、AI终端开启变革新浪潮，端侧软硬生态变革重塑；<br>
            四、智能算力步入万卡时代，全盘调度提升计算效率；<br>
            五、网络智能双向融合赋能，智算推动网络演进创新；<br>
            六、5G-A无线技术集成创新，通感智融合拓展新空间；<br>
            七、网络防御转向协同实战，智能安全范式加速形成；<br>
            八、数字技术全面规模赋能，点线面系统化推进转型；<br>
            九、数实融合释放需求潜力，全要素生产率持续提升；<br>
            十、治理体系改革持续深化，国际治理合作大有可为。<br>
            （点击注册登录查详情）<br>
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul2_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            深度剖析信息通信行业和融合领域发展态势？
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            设置四大主题板块，二十二个前沿领域专题报告，涵盖数字技术创新、人工智能、6G、低空经济、机器人、数据安全等。<br>
            包括《新型工业化-中国工业由大到强的战略、理论和实践》《解码数字中国-战略路径与未来发展》《量子前沿-解密未来技术与产业生态》《车联网新动力-数智变革赋能汽车产业转型》《低碳未来-数字化与绿色化融合之路》五本学术著作。<br>
            （点击注册登录查详情）<br>
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul3_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            为什么全球最大、最完整新能源产业链建成！下一步怎么走？
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            设置四大主题板块，二十二个前沿领域专题报告，涵盖数字技术创新、人工智能、6G、低空经济、机器人、数据安全等。<br>
            包括《新型工业化-中国工业由大到强的战略、理论和实践》《解码数字中国-战略路径与未来发展》《量子前沿-解密未来技术与产业生态》《车联网新动力-数智变革赋能汽车产业转型》《低碳未来-数字化与绿色化融合之路》五本学术著作。<br>
            （点击注册登录查详情）<br>
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul4_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            新能源
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            在清洁电力应用场景中，电动垂直起降航空器有望成为新亮点。例如，韩国现代汽车集团计划在拉斯维加斯消费电子展上展出“空中的士”概念产品。
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul5_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            超级计算机
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            欧洲的“Jupiter”超级计算机和美国的“Aurora”与“El Capitan”超级计算机将启动，用于医疗模拟和气候模拟等重要研究。
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul6_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            华为全屋智能亮相消博会
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            华为作为空间智能化时代的先行者和重要构建参与者，在第四届中国国际消费品博览会上展示了1+8+N全场景智慧生活解决方案，为消费者带来互联互通的智慧体验。
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul7_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            华为鸿蒙操作系统
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            华为副董事长徐直军在华为分析师大会上表示，2024年华为将重点打造鸿蒙原生应用生态，计划在中国市场将智能手机上使用超过99%时间的4000多个应用迁移到鸿蒙操作系统上。
          </div>
        </div>
        <div style="width: 50%;margin-top: 2rem;">
          <div
            style="width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;height: 20rem;">
            <img style="width: 50%;" :src="require('../../public/img/trends/consul8_1.png')" alt="">
          </div>
          <div style="text-align: center;font-size: 1.5rem;margin-top: 1rem;">
            红旗品牌高端手机
          </div>
          <div style="text-align: justify;width: 90%;margin: 0 auto;margin-top: 1rem;line-height: 2rem;">
            中国一汽与亿咖通科技签署了智能座舱战略合作协议，双方将共同打造红旗品牌高端手机，旨在提供极致的互联智能交互体验。
          </div>
        </div>
      </div> -->
    </div>

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        partList: [{
          title: '一图看懂生活服务周边爆品打造核心要点及热点趋势',
          url: require('../../public/img/trends/part1.png'),
        },{
          title: '做好内容和营销，激发品牌搜索新增量',
          url: require('../../public/img/trends/part2.png'),
        },{
          title: '快消品牌鏖战，用好经营策略，才能降本增效、四两拨千斤。',
          url: require('../../public/img/trends/part3.png'),
        },{
          title: '助力企业在货架场、自播、短视频、达播、广告营销等方面快速转化跃迁，实现GMV的快速提升！',
          url: require('../../public/img/trends/part4.png'),
        },{
          title: '当您店铺推出有价格优势的商品，又担心被黄牛党扫货，怎么办？怎么办？怎么办？',
          url: require('../../public/img/trends/part5.png'),
        },{
          title: '什么是商品价格力，如何提升商品价格力',
          url: require('../../public/img/trends/part6.png'),
        },{
          title: '大健康风潮下，消费需求延展，新健康、新味觉、新熟品、新包装等新形态如何快速迭代。',
          url: require('../../public/img/trends/part7.png'),
        },{
          title: '如何提前预知哪类商品卖得好、哪些内容能成爆款？',
          url: require('../../public/img/trends/part8.png'),
        }]
      };
    },

    methods: {
      routerPush(num) {
        this.$router.push({ path: '/trendsNum', query: { id: num } })
      },
      gotoJoin() {
        this.$router.push({ path: '/join' })
      },
      gotoLogin() {
        this.$router.push({ path: '/login' })
      }
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .w100 {
    width: 100%;
  }

  .w90 {
    width: 90%;
  }

  .w60 {
    width: 60%;
  }

  .w30 {
    width: 30%;
  }

  .w200 {
    width: 200px;
  }

  .minwidth {
    min-width: 1000px;
  }

  .flex {
    display: flex;
  }

  .textcent {
    text-align: center;
  }

  .fontsize50 {
    font-size: 50px;
  }

  .fontsize20 {
    font-size: 20px;
  }

  .fontsize14 {
    font-size: 14px;
  }

  .fontsize12 {
    font-size: 12px;
  }

  .fontcolorb0 {
    color: #b0b0b0;
  }

  .margincent {
    margin: 0 auto;
  }

  .margincentY {
    margin: auto 0;
  }

  .margintop20 {
    margin-top: 20px;
  }

  .margintop50 {
    margin-top: 50px;
  }

  .margintop70 {
    margin-top: 70px;
  }

  .marginleft20 {
    margin-left: 20px;
  }

  .marginbot40 {
    margin-bottom: 40px;
  }

  .paddingtop20 {
    padding-top: 20px;
  }

  .title {
    color: #000
  }

  .title:hover {
    color: #bc9158;
  }

  .positionrel {
    position: relative;

    height: 320px;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);

    width: 1920px;
    -webkit-filter: contrast(50%);
    filter: contrast(50%);
  }

  .textAlign_justify {
    text-align: justify;
  }

  .whitespace {
    white-space: pre-wrap;
    line-height: 30px;
  }

  @media screen and (max-width: 750px) {
    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }

    .flexnone {
      display: block;
    }

    .w80 {
      width: 80%;
    }

    .w300 {
      width: 300px;
    }

    .fontsize30 {
      font-size: 30px;
    }

    .marginleft20 {
      margin-left: 0;
    }

    .title {
      color: #bc9158;
    }

    .positionrel {
      position: relative;

      height: 179px;
      overflow: hidden;
    }

    .positionabs {
      position: absolute;
      left: 50%;
      transform: translate(-50%);

      width: 780px;
    }
  }
</style>